import Commodity from 'domain/commodity';
import { PositionSetting } from 'domain/positionSetting';
import { HedgingSettings } from 'features/settings/hedging/hedgingSettings';
import * as NP from 'number-precision';

export default function calculateNumberOfContracts(
    commodity: Commodity,
    quantity: number,
    useMini: boolean,
    hedgingSetting: HedgingSettings,
    positionSetting: PositionSetting): number {
    if (!quantity || !hedgingSetting)
        return 0;

    const contractSize = getContractSize(useMini, commodity, quantity);

    const contractMinOffer = getContractMinOffer(useMini, hedgingSetting, positionSetting, contractSize);

    const contractMinOfferQuantity = NP.times(NP.divide(contractSize, 100), contractMinOffer);

    let fullContracts = Math.floor(NP.divide(quantity, contractSize));

    const remainder = quantity % contractSize;
    if (remainder >= contractMinOfferQuantity)
        fullContracts += 1;

    return fullContracts;
}

export function calculateNumberOfFullContracts(commodity: Commodity, quantity: number, useMini: boolean): number {
    const contractSize = (useMini ? commodity?.miniContractSize : commodity?.contractSize) ?? quantity;

    const fullContracts = Math.floor(quantity / contractSize);
    return fullContracts;
}

function getContractSize(
    useMini: boolean,
    commodity: Commodity,
    quantity: number): number {
    if (useMini) {
        if (commodity?.miniContractSize)
            return commodity.miniContractSize;
    } else {
        if (commodity?.contractSize)
            return commodity.contractSize;
    }

    return quantity;
}

function getContractMinOffer(
    useMini: boolean,
    hedgingSetting: HedgingSettings,
    positionSetting: PositionSetting,
    contractSize: number): number {
    if (useMini) {
        if (hedgingSetting.useMiniContractMinOfferFromPosition && positionSetting?.miniContractMinimum)
            return positionSetting.miniContractMinimum;

        if (hedgingSetting.miniContractMinOffer)
            return hedgingSetting.miniContractMinOffer;
    } else {
        if (hedgingSetting.useFullContractMinOfferFromPosition && positionSetting?.fullContractMinimum)
            return positionSetting.fullContractMinimum;

        if (hedgingSetting.fullContractMinOffer)
            return hedgingSetting.fullContractMinOffer;
    }

    return contractSize;
}